class ProductDescriptionAccordion extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    const source = this.querySelector('.ag-product-description__source');
    const target = this.querySelector('.ag-product-description__items');
    if (!source || !target) return;

    const names = new Map([
      ['description', 'Description'],
      ['key benefits', 'Key Benefits'],
      ['perfect for', 'Perfect For'],
      ['why buy from arctic glow', 'Why Buy from Arctic Glow?'],
      ['size', 'Size'],
      ['ingredients', 'Ingredients'],
      ['how to use', 'How to Use'],
      ['technical details', 'Technical Details'],
      ['precautions', 'Precautions'],
    ]);

    const groups = [];
    let current = { title: 'Description', nodes: [] };
    const pushCurrent = () => {
      if (current.nodes.some((node) => node.textContent?.trim() || node.nodeType === Node.ELEMENT_NODE)) {
        groups.push(current);
      }
    };

    [...source.childNodes].forEach((node) => {
      const isHeading = node.nodeType === Node.ELEMENT_NODE && /^H[1-6]$/.test(node.tagName);
      const normalized = isHeading
        ? node.textContent.trim().toLowerCase().replace(/[?:]+$/g, '').replace(/\s+/g, ' ')
        : '';

      if (isHeading && names.has(normalized)) {
        pushCurrent();
        current = { title: names.get(normalized), nodes: [] };
        return;
      }

      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'HR') return;
      current.nodes.push(node.cloneNode(true));
    });
    pushCurrent();

    groups.forEach((group, index) => {
      const details = document.createElement('details');
      if (index === 0 && this.dataset.openFirst === 'true') details.open = true;

      const summary = document.createElement('summary');
      const label = document.createElement('span');
      const icon = document.createElement('span');
      const content = document.createElement('div');

      label.textContent = group.title;
      icon.className = 'ag-product-description__icon';
      icon.setAttribute('aria-hidden', 'true');
      content.className = 'ag-product-description__content rte';
      group.nodes.forEach((node) => content.appendChild(node));

      summary.append(label, icon);
      details.append(summary, content);
      target.appendChild(details);
    });
  }
}

if (!customElements.get('product-description-accordion')) {
  customElements.define('product-description-accordion', ProductDescriptionAccordion);
}
